module.exports = __webpack_public_path__ + "static/media/icon-customer-reorder.bbc5e89f.svg";